<template>
  <div class='mt-1'>
    <b-modal
      ref='archivedRoles'
      id='archivedRoles'
      hide-footer
      hide-header
      header-bg-variant='info'
      header-text-variant='light'
      size='xl'
      @show='showModal()'
    >
      <b-overlay
        :show='lookingForRoles'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <section class='modal-font-family'>
          <section class='mb-3'>
            <section class='d-flex align-content-center justify-content-between '>
              <section>
                <p class='products-title mt-1'>
                  Cargos arquivados do setor
                </p>
              </section>

              <section>
                <b-icon
                  style='cursor: pointer'
                  @click='closeModal()'
                  class='ml-1'
                  font-scale='2.5'
                  icon='x'
                  color='#262626'
                >
                </b-icon>
              </section>
            </section>
            <section>
              <p class='products-sub-title'>
                Selecione os cargos que deseja desarquivar. É possível selecionar mais de um.
              </p>
            </section>
          </section>

          <section v-if='sectorRoles.length === 0' class='empty-message'>
            <p>Não há cargos arquivados neste setor.</p>
          </section>

          <section
            v-else
            style='display: grid;  grid-template-columns: repeat(auto-fill, minmax(25%, auto)); min-height: 80px'
          >
            <b-form-checkbox-group
              v-model='selected'
              v-for='(sectorRole, i) in sectorRoles'
              :key='i'
              class='product'
              size='lg'
            >
              <b-form-checkbox
                class=''
                :value='sectorRole._id'
              >
                <p class='word-break product-name mt-2'>{{ sectorRole.role && sectorRole.role.name }}</p>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </section>

          <section class='d-flex justify-content-between mt-4'>
            <base-button
              class='w-25 mr-3 btn-cancel'
              @click='closeModal()'
            >
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-75'
            >
              <base-button
                class='w-100 btn-add d-flex align-items-center justify-content-center'
                :disabled='disabled'
                @click='unarchive()'
              >
                <span class='mr-2'> Desarquivar cargos selecionados </span>
              </base-button>
            </b-overlay>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 2rem; height: 2rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h6 class='text-primary'>Buscando cargos arquivados...</h6>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ArchivedRoles',
  components: {},
  props: {
    sectorId: {
      type: String,
      required: false,
      default: null
    },
    tab: {
      type: String,
      required: false,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      lookingForRoles: false,
      sectorRoles: [],
      selected: []
    }
  },
  computed: {
    disabled() {
      return this.selected.length === 0
    }
  },
  methods: {
    ...mapActions('role', {
      handleGetArchivedBySector: 'handleGetArchivedBySector',
      handleUnarchive: 'handleUnarchive'
    }),
    async showModal() {
      try {
        this.loading = false
        this.selected = []
        await this.getArchivedRoles()
      } catch (e) {

      }
    },

    async getArchivedRoles() {
      try {
        this.lookingForRoles = true
        const { data } = await this.handleGetArchivedBySector(this.sectorId)
        this.sectorRoles = data && data.sectorRoles ? data.sectorRoles : []
        this.lookingForRoles = false
      } catch (e) {
      }
    },

    async unarchive() {
      try {
        this.loading = true
        const responses = await Promise.all(
          this.selected.map((sectorRoleId) => this.handleUnarchive({ sectorRoleId, tab: this.tab }))
        )
        this.loading = false
        const hasError = responses.some((response) => !response || response.status !== 200)
        this.$bvToast.toast(
          hasError
            ? 'Não foi possível desarquivar todos os cargos, tente novamente.'
            : 'Cargos desarquivados com sucesso',
          {
            title: 'Atenção',
            variant: hasError ? 'danger' : 'success',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000
          }
        )
        await this.closeModal()
        this.$emit('update')
      } catch (e) {
      }
    },

    closeModal() {
      this.$bvModal.hide('archivedRoles')
    }
  }
}
</script>
<style lang='scss' scoped>
.products-title {
  color: #262626;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.products-sub-title {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: -10px
}

.empty-message {
  color: #808080;
  font-size: 14px;
  min-height: 80px;
}

.product {
  border-radius: 10px;
  border: 1px solid var(--navy-blue);
  padding: 5px;
  margin: 12px 12px 0 0;
}

.product-name {
  color: var(--navy-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}
</style>
